import React from "react";
import toast from "toastr";
import { saveAs } from 'file-saver'
import { ActionIcon, rem } from '@mantine/core';
import { IconDots, IconEye, IconDownload } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../components/mantine/menu";

const ActionMenuBySiteId = (props:any) => {
    const { setSelectedRows, item }=props;
    const handleViews = () => {
        if (item && item.url) {    
        window.open(item.url, "_blank")
        }
        else {    
            toast.error('Item is undefined or null')
        }
        setSelectedRows(item); 
    };
    
    const handleDownload = async () => {
        debugger
        if (item && item.url) { 
            try {
                const geturl = await fetch(item.url);
                //const blob = await geturl.blob();
                const contentType = geturl.headers.get('Content-Type');
                if (!contentType) {
                    throw new Error("Content-Type header is missing");
                }
                let extension = '';
                if (contentType.includes('image/jpeg')) {
                    extension = '.jpg';
                } else if (contentType.includes('application/pdf')) {
                    extension = '.pdf';
                } else {
                    extension = ''; 
                }
    
                const filename = item.manualName ? `${item.manualName}${extension}` : `download${extension}`; 
                // const blobUrl = window.URL.createObjectURL(blob);
                // const link = document.createElement('a');
                // link.href = blobUrl;
                // link.setAttribute('download', filename); 
    
                // document.body.appendChild(link);
                // link.click();
                // link.parentNode?.removeChild(link);
                // window.URL.revokeObjectURL(blobUrl);
                saveAs(item.url, filename);
            } catch (error) {
                //console.error('Error downloading the file:', error);
                //toast.error('Failed to download file. Please try again later.');
                window.open(item.url, "_blank");
            }
        } else {
            toast.error('Invalid item or URL.');
        }
    };
    
    
    return (
        <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
            <MantineMenuTarget>
                <div style={{ textAlign: 'right' }}>
                    <ActionIcon variant="subtle" color="gray">
                        <IconDots style={{ width: rem(16), height: rem(16) }} />
                    </ActionIcon>
                </div>
            </MantineMenuTarget>
            <MantineMenuDropdown>
            <MantineMenuItem
                    leftSection={<IconEye style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={handleViews}
                >
                    view
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconDownload style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={handleDownload}
                >
                    download
                </MantineMenuItem>
            </MantineMenuDropdown>
        </MantineMenu>
    );
};


export default ActionMenuBySiteId;

